/** Admin panel i18n translations - EN + TR */
const ADMIN_T = {
  en: {
    // Common
    loading: 'Loading...', save: 'Save', cancel: 'Cancel', delete: 'Delete',
    edit: 'Edit', create: 'Create', update: 'Update', refresh: 'Refresh',
    preview: 'Preview', search: 'Search', filter: 'Filter', allTypes: 'All Types',
    allLanguages: 'All Languages', noData: 'No data found', confirm: 'Are you sure?',
    yes: 'Yes', no: 'No', active: 'Active', inactive: 'Inactive', published: 'Published',
    draft: 'Draft', back: 'Back', close: 'Close', actions: 'Actions',

    // SEO Dashboard
    seoDashboard: 'SEO Dashboard', clearCache: 'Clear Cache',
    aiEngine: 'AI Engine', totalContent: 'Total Content', match: 'Match',
    league: 'League', failures: 'Failures', avgTime: 'Avg Time', avgTokens: 'Avg Tokens',
    contentByLanguage: 'Content by Language', contentGeneration: 'Content Generation',
    allMatches: 'All Matches', allLeagues: 'All Leagues', allBookmakers: 'All Bookmakers',
    allPredictions: 'All Predictions', programmatic: 'Programmatic', expired: 'Expired',
    allFaqs: 'All FAQs', allTrends: 'All Trends', allInsights: 'All Insights',
    qualityScores: 'Quality Scores', regenMatches: 'Regen Matches', regenLeagues: 'Regen Leagues',
    regenBookmakers: 'Regen Bookmakers', pageQuality: 'Page Quality', seoGrowthHealth: 'SEO Growth Health',
    predictions: 'Predictions', faqs: 'FAQs', trends: 'Trends', insights: 'Insights',
    indexingControl: 'Indexing Control', scored: 'Scored', indexable: 'Indexable', noindex: 'Noindex',
    total: 'Total', withAi: 'With AI', withOdds: 'With Odds', thin: 'Thin',
    content: 'Content', generationLogs: 'AI Generation Logs', manageFrom: 'Manage from',
    promptManager: 'AI Prompt Manager', keywordManager: 'SEO Keyword Manager',
    prompts: 'Prompts', keywords: 'Keywords',

    // Prompt Manager
    aiPromptManager: 'AI Prompt Manager', newPrompt: 'New Prompt',
    createPrompt: 'Create New Prompt', promptKey: 'Prompt Key',
    promptText: 'Prompt Text', systemPrompt: 'System Prompt (optional)',
    pageType: 'Page Type', blockType: 'Block Type', language: 'Language',
    version: 'Version',

    // Keyword Manager
    seoKeywordManager: 'SEO Keyword Manager', newKeywords: 'New Keywords',
    newKeywordEntry: 'New Keyword Entry', primaryKeywords: 'Primary Keywords',
    secondaryKeywords: 'Secondary Keywords', negativeKeywords: 'Negative Keywords',
    commaSeparated: 'comma separated',

    // Language Settings
    languageToneSettings: 'Language & Tone Settings', toneStyle: 'Tone',
    professionalism: 'Professionalism', friendliness: 'Friendliness',
    sentenceLength: 'Sentence Length', seoIntensity: 'SEO', includeCta: 'CTA',
    bettingSafety: 'Safety',

    // Pages Manager
    pagesManager: 'Pages Manager', newPage: 'New Page', createPage: 'Create Page',
    editPage: 'Edit Page', title: 'Title', metaTitle: 'Meta Title',
    metaDescription: 'Meta Description', ogTitle: 'OG Title', ogDescription: 'OG Description',
    contentHtml: 'Content HTML', faqItems: 'FAQ Items', indexableLabel: 'Indexable',
    footer: 'Footer', header: 'Header', slug: 'Slug', status: 'Status',
  },
  tr: {
    // Common
    loading: 'Yukleniyor...', save: 'Kaydet', cancel: 'Iptal', delete: 'Sil',
    edit: 'Duzenle', create: 'Olustur', update: 'Guncelle', refresh: 'Yenile',
    preview: 'Onizleme', search: 'Ara', filter: 'Filtre', allTypes: 'Tum Tipler',
    allLanguages: 'Tum Diller', noData: 'Veri bulunamadi', confirm: 'Emin misiniz?',
    yes: 'Evet', no: 'Hayir', active: 'Aktif', inactive: 'Pasif', published: 'Yayinda',
    draft: 'Taslak', back: 'Geri', close: 'Kapat', actions: 'Islemler',

    // SEO Dashboard
    seoDashboard: 'SEO Paneli', clearCache: 'Onbellek Temizle',
    aiEngine: 'AI Motoru', totalContent: 'Toplam Icerik', match: 'Mac',
    league: 'Lig', failures: 'Hatalar', avgTime: 'Ort. Sure', avgTokens: 'Ort. Token',
    contentByLanguage: 'Dil Bazli Icerik', contentGeneration: 'Icerik Uretimi',
    allMatches: 'Tum Maclar', allLeagues: 'Tum Ligler', allBookmakers: 'Tum Bahis Siteleri',
    allPredictions: 'Tum Tahminler', programmatic: 'Programatik', expired: 'Suresi Dolmus',
    allFaqs: 'Tum SSS', allTrends: 'Tum Trendler', allInsights: 'Tum Analizler',
    qualityScores: 'Kalite Puanlari', regenMatches: 'Maclar Yenile', regenLeagues: 'Ligler Yenile',
    regenBookmakers: 'Bahisciler Yenile', pageQuality: 'Sayfa Kalitesi', seoGrowthHealth: 'SEO Buyume Sagligi',
    predictions: 'Tahminler', faqs: 'SSS', trends: 'Trendler', insights: 'Analizler',
    indexingControl: 'Indeksleme Kontrolu', scored: 'Puanlanan', indexable: 'Indekslenebilir', noindex: 'Indekslenmez',
    total: 'Toplam', withAi: 'AI Icerikli', withOdds: 'Oranli', thin: 'Zayif',
    content: 'Icerik', generationLogs: 'AI Uretim Loglari', manageFrom: 'Yonet:',
    promptManager: 'AI Prompt Yoneticisi', keywordManager: 'SEO Kelime Yoneticisi',
    prompts: 'Promptlar', keywords: 'Kelimeler',

    // Prompt Manager
    aiPromptManager: 'AI Prompt Yoneticisi', newPrompt: 'Yeni Prompt',
    createPrompt: 'Yeni Prompt Olustur', promptKey: 'Prompt Anahtari',
    promptText: 'Prompt Metni', systemPrompt: 'Sistem Promptu (istege bagli)',
    pageType: 'Sayfa Tipi', blockType: 'Blok Tipi', language: 'Dil',
    version: 'Surum',

    // Keyword Manager
    seoKeywordManager: 'SEO Anahtar Kelime Yoneticisi', newKeywords: 'Yeni Kelimeler',
    newKeywordEntry: 'Yeni Kelime Kaydi', primaryKeywords: 'Birincil Kelimeler',
    secondaryKeywords: 'Ikincil Kelimeler', negativeKeywords: 'Negatif Kelimeler',
    commaSeparated: 'virgul ile ayirin',

    // Language Settings
    languageToneSettings: 'Dil ve Ton Ayarlari', toneStyle: 'Ton',
    professionalism: 'Profesyonellik', friendliness: 'Samimiyet',
    sentenceLength: 'Cumle Uzunlugu', seoIntensity: 'SEO', includeCta: 'CTA',
    bettingSafety: 'Guvenlik',

    // Pages Manager
    pagesManager: 'Sayfa Yoneticisi', newPage: 'Yeni Sayfa', createPage: 'Sayfa Olustur',
    editPage: 'Sayfa Duzenle', title: 'Baslik', metaTitle: 'Meta Baslik',
    metaDescription: 'Meta Aciklama', ogTitle: 'OG Baslik', ogDescription: 'OG Aciklama',
    contentHtml: 'Icerik HTML', faqItems: 'SSS Maddeleri', indexableLabel: 'Indekslenebilir',
    footer: 'Footer', header: 'Header', slug: 'Slug', status: 'Durum',
  },
};

export function useAdminT() {
  const lang = typeof window !== 'undefined' ? localStorage.getItem('admin_lang') || 'en' : 'en';
  const t = ADMIN_T[lang] || ADMIN_T.en;
  return t;
}

export default ADMIN_T;
